(function ($) {
  let hasLoadedOnce = false;

  function updateAutoRefresh() {
    const FWP = window.FWP;
    if (768 < window.innerWidth) {
      FWP.auto_refresh = true;
    } else {
      FWP.auto_refresh = false;
    }

    window.FWP = FWP;
  }

  $(document).on('facetwp-refresh', function () {
    const FWP = window.FWP;

    if ('undefined' !== typeof FWP) {
      if (!hasLoadedOnce) {
        hasLoadedOnce = true;
      } else {
        FWP.enable_scroll = true;
        FWP.please_scroll_there = '#listing-products';
      }
    }

    window.FWP = FWP;
  });

  $(function () {
    const FWP = window.FWP;
    if ('undefined' !== typeof FWP) {
      $('.reset-filters').on('click', function () {
        FWP.reset();
      });
    }
  });

  $(document).on('facetwp-loaded', function () {
    const FWP = window.FWP;

    if ('' === FWP.buildQueryString()) {
      $('.product-filters__selection').addClass('sectionHidden');
    } else {
      $('.product-filters__selection').removeClass('sectionHidden');
    }
  });

  window.addEventListener('resize', function () {
    updateAutoRefresh();
  });

  /* mobile toggle */

  window.addEventListener('load', function () {
    const filtersToggle = document.getElementById('filters-toggle');
    const filtersWrapper = document.getElementById('filters-wrapper');
    const filtersApply = document.querySelectorAll('.applyFilters');

    function closeFilters() {
      filtersWrapper.classList.remove('opened');
      filtersToggle.querySelector('span').textContent = wp.i18n._x(
        'Show filters',
        'filters toggle btn',
        'vtx'
      );
      filtersToggle.setAttribute('aria-expanded', 'true');

      updateAutoRefresh();
    }

    function openFilters() {
      filtersWrapper.classList.add('opened');
      filtersToggle.querySelector('span').textContent = wp.i18n._x(
        'Hide filters',
        'filters toggle btn',
        'vtx'
      );
      filtersToggle.setAttribute('aria-expanded', 'true');
    }

    if (filtersToggle) {
      filtersToggle.addEventListener('click', function () {
        if (filtersWrapper.classList.contains('opened')) {
          closeFilters();
        } else {
          openFilters();
        }
      });
      document.addEventListener('facetwp-loaded', function () {
        closeFilters();
      });
    }

    if (0 < filtersApply.length) {
      filtersApply.forEach(function (applyBtn) {
        applyBtn.addEventListener('click', function () {
          window.FWP.refresh();
          closeFilters();
        });
      });
    }
  });
})(jQuery);
